import moment from "moment";
import {IApp} from "@/interfaces/app.interface";

export const compareHelper = {
  compareArrays: (arr1, arr2) => {
    if (!arr1 || !arr2) return false
    if (arr1.length !== arr2.length) return false

    const sorted1 = [...arr1].sort((a, b) => a - b)
    const sorted2 = [...arr2].sort((a, b) => a - b)

    return sorted1.every((value, index) => value === sorted2[index])
  },

  compareDates: (date1: string, date2: string) => {
    let dateNew = date1 ? moment(date1).format(IApp.DateFormats.ToServer) : '';
    let dateOld = date2 ? moment(date2).format(IApp.DateFormats.ToServer) : '';
    return dateNew !== dateOld;
  },
};